import React from 'react';
import ReactModal from 'react-modal';
import { CloseIcon } from '../../../components/icons';

const AddIldConfirmationModal = ({
  modalText,
  simDetailData,
  updateIldIrInfo,
  updateLoading,
  closeModal,
  addIldConfirmationModal,
}) => {
  const ILDDisabled = simDetailData.isILDEnabled === 0;
  const buttonText = ILDDisabled ? `Yes, I'm sure` : `Yes, Disable`;
  const buttonClass = ILDDisabled
    ? `btn btn-dark w-100`
    : `btn btn-lg btn-danger w-100`;
  return (
    <ReactModal
      isOpen={addIldConfirmationModal}
      onRequestClose={closeModal}
      ariaHideApp={false}
      contentLabel="Are you sure?"
      portalClassName="react-modal"
      overlayClassName="modal"
      className="modal-dialog modal-dialog-centered"
    >
      <div className="modal-content">
        <div className="react-modal-body">
          <button
            type="button"
            className="btn react-modal-close"
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <h5 className="react-modal-title">
            {modalText} International Long Distance Minutes
          </h5>
          <p className="react-modal-subtitle mt-2">
            Are you sure you want to {ILDDisabled ? `Enable` : `Disable`}{' '}
            International Long Distance Minutes Capabilities on this line{' '}
            {simDetailData.msisdn} with SIM {simDetailData.simnumber}?
          </p>
          <div className="text-right mt-3">
            <button
              disabled={updateLoading}
              type="button"
              onClick={() => updateIldIrInfo('isILDEnabled', 'ild')}
              className={buttonClass}
            >
              {updateLoading ? 'Please wait...' : buttonText}
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default AddIldConfirmationModal;
